<mat-toolbar id="main-toolbar" class="mat-elevation-z2">
  <div class="flex-row items-center w-100">
    <a class="logo" routerLink="/" ><app-logo [logoType]="0"></app-logo></a>
    @if (showPropertySearch) {
      <app-properties-search-box class="search-box" (searchItemSelected)="onSearchItemSelected($event)"></app-properties-search-box>
    }
    <div class="toolbar-actions flex-row justify-end items-center">
      <app-horizontal-menu class="horizontal-menu hide-lt-xl" [menuParentId]="0" [isRootMenu]="true"></app-horizontal-menu>
      @if ((authenticated | async) == true && isSuperAdmin) {
        <div class="hide-lt-xl flex-row justify-start items-center">
          <a routerLink="/account/todo" mat-icon-button matTooltip="To Do List" hidden class="warn-badge">
            <mat-icon [matBadge]="toDoCount"
              [matBadgeHidden]="toDoCount == 0"
              matBadgeSize="medium"
              matBadgeColor="warn"
              aria-hidden="false"
              aria-label="{{toDoCount}} to do's">whatshot</mat-icon>
          </a>
          <a routerLink="/account/favorites" mat-icon-button matTooltip="Favorites" class="warn-badge">
            @let favCount = (favoriteProperties | async)?.length ?? 0;
            <mat-icon [matBadge]="favCount"
              [matBadgeHidden]="!(favCount > 0)"
              matBadgeSize="medium"
              matBadgeColor="warn"
              aria-hidden="false"
              aria-label="{{favCount}} favorite properties">favorite_border</mat-icon>
          </a>
          @if (compareVisible) {
            <a routerLink="/account/compare" mat-icon-button matTooltip="Compare list" class="warn-badge">
              @let compCount = (comparableProperties | async)?.length ?? 0;
              <mat-icon [matBadge]="compCount"
                [matBadgeHidden]="!(compCount> 0)"
                matBadgeSize="medium"
                matBadgeColor="warn"
                aria-hidden="false"
                aria-label="{{compCount}} compare properties">compare_arrows</mat-icon>
            </a>
          }
        </div>
      }
      @if (showPropertySearch) {
        <button mat-icon-button class="search-toggle" (click)="openSearchOverlay()" aria-label="Search properties">
          <mat-icon>search</mat-icon>
        </button>
      }
      <div class="hide-gt-lg ml-2">
        <button mat-icon-button (click)="sidenavToggle()">
          <mat-icon>menu</mat-icon>
        </button>
      </div>
    </div>
  </div>
  <!-- phones: search box slides over the toolbar instead of sitting inline -->
  @if (showPropertySearch && searchOverlayOpen) {
    <div class="search-overlay flex-row items-center" animate.enter="search-overlay-enter" (keydown.escape)="closeSearchOverlay()">
      <app-properties-search-box class="flex-1" (searchItemSelected)="onSearchItemSelected($event)"></app-properties-search-box>
      <button mat-icon-button class="ml-1" (click)="closeSearchOverlay()" aria-label="Close search">
        <mat-icon>close</mat-icon>
      </button>
    </div>
  }
</mat-toolbar>

